import { render, staticRenderFns } from "./learningState.vue?vue&type=template&id=9bd18854&scoped=true"
import script from "./learningState.vue?vue&type=script&lang=js"
export * from "./learningState.vue?vue&type=script&lang=js"
import style0 from "./learningState.vue?vue&type=style&index=0&id=9bd18854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd18854",
  null
  
)

export default component.exports